
import React, { useEffect, useState, useCallback } from "react";
import cn from "classnames";
import Master from "screen/Master";
import styles from "./Pricing.module.scss";
import { Link, useHistory } from "react-router-dom";
import NewTableList from "components/common/NewTableList";
import { getRequest as getRequestForPrice } from "services/axiosBaseClient";
import ServiceRequestViewMaster from "components/common/ServiceRequestViewTableMaster";

var tempTigger;

function Pricing(props) {
  
  const history = useHistory();
  const [text, setText] = useState("Active");
  const [priceListData, setPriceListData] = useState([])
  const [priceCountData, setPriceCountData] = useState([])

  useEffect(() => {
    tempTigger = !history?.location?.compomentRenderType
      ? "init"
      : history?.location?.compomentRenderType === "amhitted"
      ? "amhitted"
      : history?.location?.compomentRenderType === "view"
      ? "view"
      : "amhitted";
  }, [
    history?.location?.state?.compomentRenderType ||
      props.history?.location?.state?.compomentRenderType,
  ]);

  const getPriceList = useCallback(async (searchString) => {
      getRequestForPrice('bss/getPricePlanList?' + searchString).then((res) => {
        if (res && res?.data) {
          setPriceListData(res.data.pricePlan);
          setPriceCountData(res?.data.priceCount);
        }
      }).catch((err) => {
        if (err) {
          setPriceListData([])
        }
      });
    }, []);

  useEffect(() => {
    window.scrollTo({ top: 0 });
    getPriceList();
  }, []);

  useEffect(() => {
    localStorage.setItem("activeTabCount", "zoneAsset");
  }, []);

  const columns = React.useMemo(() => [
    {
      Header: "Price Name",
      accessor: "priceName",
      // width: "40%",
    },
    {
      Header: "Unit Price/kWh",
      accessor: "price",
      // width: "30%",
      Cell: (row) => {
        return  <div style={{ paddingLeft:"20px"}}>{row.row?.original?.price? Number(row.row?.original?.price).toFixed(2) : 0}</div>;
      },
    },
    {
      Header: "Status",
      // accessor: "status",
      width: "15%",
      Cell: (res) => {
        return (
          <>{res?.row.original?.status ? (
            <p style={{
              display: "flex",
              justifyContent: "center",
              cursor: "default",
              background: "#1A873C",
              border: "1px",
              width: "80px",
              color: "#fff",
              borderRadius: "5px",
              margin: "3px 0px 2px 2px",
              padding: "3px 0px",
            }}>
              <span style={{ margin: "0px" }}>
                Active
              </span>
            </p>
          ) : (
            <p style={{
              display: "flex",
              justifyContent: "center",
              cursor: "default",
              background: "#C71720",
              border: "1px",
              width: "80px",
              color: "#fff",
              borderRadius: "5px",
              margin: "3px 0px 2px 2px",
              padding: "3px 0px",
            }}>
              <span style={{ margin: "0px" }}>
                InActive
              </span>
            </p>
          )}

          </>
        );
      },
    },
  ]);

  var searchByKey = () => { };

  return (
    <>
      <h2 id="Pricing_Heading" className={cn(styles.medium_title, styles.medium_title_layout)}>
        {"Price List"}
      </h2>

      <div id="Pricing_TotalCount_Container" className={cn(styles.flex2, styles.flex2_layout)}>
        <div id="Pricing_TotalCount_Container1" className={cn(styles.flex2_item)}>
          <div id="Pricing_TotalCount_Cblock" className={cn(styles.block1, styles.block1_layout)}>
            <img
            id="Pricing_TotalCount_img"
              src={require("assets/rupee-white 1.svg").default}
              alt="Rectangle 16663"
              className={cn(styles.box1, styles.box1_layout)}
            />
          </div>
        </div>

        <div className={cn(styles.flex2_spacer)} />
        <div id="Pricing_TotalCount_TextLayout" className={cn(styles.flex2_item1)}>
          <div id="Pricing_TotalCount_TextBlock" className={cn(styles.block2, styles.block2_layout)}>
            {/* <h3 className={cn(styles.small_title, styles.small_title, styles.small_title_bold )}> */}
            <h2 id="Pricing_TotalCount_title" className={cn(styles.medium_title, styles.medium_title_layout)}>
              {"Total Count"}

            </h2>
            <h2 id="Pricing_TotalCount_value" className={cn(styles.medium_title, styles.medium_title_layout)}>
              {priceCountData}
            </h2>
          </div>
        </div>

        <div className={cn(styles.flex2_spacer3)} />

        <div className={cn(styles.group, styles.group_layout)}>
          <div className={cn(styles.block5, styles.block5_layout)}>
            <Link to="/Pricing/Addpricing">
              <div id="Pricing_AddPrice_block" className={cn(styles.flex3, styles.flex3_layout)}>
                <div id="Pricing_AddPrice_layout" className={cn(styles.block7, styles.block7_layout)}>
                  <div id="Pricing_AddPrice" className={cn(styles.block7_item)}>
                    <img
                    id="Pricing_AddPrice_img"
                      src={require("assets/Vector (5).png").default}
                      alt="Rectangle 16663"
                    />
                  </div>

                  <div
                   id="Pricing_AddPrice_Title"
                    className={cn(styles.text_body, styles.text_body_layout, styles.pdr10)}
                  >
                    {"Add Price"}
                  </div>
                </div>
              </div>
            </Link>
          </div>
        </div>
      </div>

      <div
        style={{
          borderRadius: "7px",
          backgroundColor: "rgb(252, 252, 252)",
          marginTop: "20px",
          boxShadow: "rgb(35 41 122 / 25%) 0px 3px 8px 2px",
          overflowX: "auto",
        }}
      >
        {/* <NewTableList */}
        <ServiceRequestViewMaster
          searchOpts={{
            placeholder: "Search by Swapping Station",
            filter: true,
            onFilterSearch: getPriceList,
            screentype: "swapping",
          }}
          tigger={tempTigger}
          columns={columns}
          data={priceListData}
          paginationDoubleScreen={true}
          swapStationCount={priceCountData}
        />
      </div>
    </>
  );
}

export default function PriceList(props) {
  const [headerFilter, setHeaderFilter] = useState(true);
  return (
    <>
      <Master opts={props} screen={Pricing} showStatus={false}
        headerFilter={headerFilter}
        setHeaderFilter={setHeaderFilter} 
       />
    </>
  );
}
PriceList.inStorybook = true;
